declare namespace $ {

	type $mol_link__current_shm_projects_docs_1 = $mol_type_enforce<
		ReturnType< $shm_projects_docs['readme_current'] >
		,
		ReturnType< $mol_link['current'] >
	>
	type $mol_link__arg_shm_projects_docs_2 = $mol_type_enforce<
		({ 
			'docs_file': any,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_shm_projects_docs_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__sub_shm_projects_docs_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_link__current_shm_projects_docs_5 = $mol_type_enforce<
		ReturnType< $shm_projects_docs['agents_current'] >
		,
		ReturnType< $mol_link['current'] >
	>
	type $mol_link__arg_shm_projects_docs_6 = $mol_type_enforce<
		({ 
			'docs_file': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_shm_projects_docs_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__sub_shm_projects_docs_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_view__sub_shm_projects_docs_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_projects_docs extends $shm_hitalama_textbook {
		mode_text( ): string
		readme_current( ): boolean
		Readme( ): $mol_link
		agents_current( ): boolean
		Agents( ): $mol_link
		readme_text( ): string
		agents_text( ): string
		text( ): ReturnType< $shm_projects_docs['mode_text'] >
		Modes( ): $mol_view
	}
	
}

//# sourceMappingURL=docs.view.tree.d.ts.map